import { ArchiveApi, Configuration, DownloadApi, LoginApi } from "../axios";

// 環境別のapi接続先
const BASE_PATH = require('../.env/_env').BASE_PATH;

/**
 * Db関連のutilクラス。
 */
export class DbUtils {

	static readonly config: Configuration = new Configuration({
		basePath: BASE_PATH,
	});

	/**
	 * ログイン関連のapiを返す。
	 * 
	 * @returns 
	 */
	static getLoginApi() {
		return new LoginApi(this.config);
	}

	/**
	 * 文書アーカイブ関連のzpiを返す。
	 * 
	 * @returns 
	 */
	static getArchiveApi() {
		return new ArchiveApi(this.config);
	}

	/**
	 * ダウンロード履歴関連のapiを返す。
	 * 
	 * @returns 
	 */
	static getDownloadApi() {
		return new DownloadApi(this.config);
	}

}
